export { toolbarVariables as toolbarMenuItemIconVariables } from './toolbarVariables';
